<template>
    <div class="about">
        <!-- 图片 -->
        <div class="banner">
            <img src="../assets/img/about/1.png" alt="">
            <h2>关于我们</h2>
        </div>
        <div class="content">
            <div class="content-top">
                <div class="top-left">
                    <img src="../assets/img/about/2.png" alt="">
                </div>
                <div class="top-right">
                    <h3>北京纸搬客科技有限公司（简称“纸搬客”） 成立于2018年1月19日，注册资本1000万元人民币</h3>
                    <p>
                        北京纸搬客科技有限公司在国家密集提出“未来经济”、“绿色经济”、“共享经济”规划的时代转折大背景下，创新整合资源，聚焦环保服务，精准定位痛点，以创新的思想，形成以“手机APP+智能硬件”为载体，以“环保+传媒+电商”为核心，以大数据、物联网、云计算、电子商务为内核的创新发展服务模式，为老百姓日常生活、商业主体经营宣传、全民环保意识教育服务，孕育出创新型服务平台。
                    </p>
                </div>
            </div>
            <div class="content-bottom">
                <div class="bottom-left">
                    <h3>运营模式</h3>
                    <p>
                        纸搬客以设备为圆心的运营模式扫码立即开启设备，随手投递立即称重，赚取积分，可自由选择提现或兑换商品，桶满预警后，回收小哥立即到位，回收与配送相结合的团队，可在回收纸张的同时，将用户的兑换商品送货上门，纸张回收后，流向纸搬客分拣打包中心，最终到达纸厂完成再造。
                    </p>
                </div>
                <div class="bottom-right">
                    <img src="../assets/img/about/3.png" alt="">
                </div>
            </div>
        </div>
        <!-- 纸搬客智慧城市——环保大数据系统。 -->
        <div class="city">
            <h3>纸搬客智慧城市——环保大数据系统</h3>
            <p>纸搬客自主研发的大数据系统，通过数据分析可提供回收数据预测</p>
            <p>价格波动预测，可监督，可追溯，结合多方位数据完成</p>
            <p>回收智能化、处理标准化，重建环保生态链。</p>
        </div>
        <!-- 纸搬客各项资质证书。 -->
        <!-- <div class="credential">
            <h3>纸搬客各项资质证书</h3>
            <book_s></book_s>
        </div> -->
        <!-- footer -->
        <footer_s></footer_s>   
    </div>
</template>
<script>
    import book_s from './common/book'
    import $ from 'jquery'
    import footer_s from './common/footer'
    export default {
        components: {
            footer_s,
            book_s,
        },
        data(){
            return{
                arr:[
                    require('../assets/img/about/5.png'),
                    require('../assets/img/about/6.png'),
                    require('../assets/img/about/7.png'),
                    require('../assets/img/about/8.png'),
                    require('../assets/img/about/9.png'),
                    require('../assets/img/about/10.png'),
                    require('../assets/img/about/11.png'),
                ]
            }
        },
        mounted(){
            $(function () {
                $('.banner h2').animate({
                    opacity:1
                })
                $(window).scroll(function () {
                    var scrollT = $(window).scrollTop(); //滚动的高度
                    var ViewHeight = $(window).height(); //视口的高度
                    var contentTHeight = $('.content-top').offset().top; //元素的高度
                    var contentBHeight = $('.content-bottom').offset().top; //元素的高度
                    var cityHeight = $('.city').offset().top; //元素的高度
                    if (scrollT + ViewHeight >= contentTHeight) {
                        $('.top-left').addClass('animated fadeInLeftBig')
                        $('.top-right').addClass('animated fadeInRightBig')
                        $('.top-right h3, .top-right p').animate({
                            opacity:1
                        },2000)
                    }
                    if (scrollT + ViewHeight >= contentBHeight) {
                        $('.bottom-left').addClass('animated fadeInLeftBig')
                        $('.bottom-right').addClass('animated fadeInRightBig')
                        $('.bottom-left h3,.bottom-left p').animate({
                            opacity:1
                        },2000)
                    }
                    if (scrollT + ViewHeight >= cityHeight) {
                        $('.city h3,.city p').animate({
                            opacity:1
                        },2000)
                    }
                })
            })
        },
        beforeDestroy(){
            $(window).off('scroll')
        }
    }
</script>
<style scoped>
    .about {
        width: 100%;
        height: 100%;
    }

    .banner {
        position: relative;
        height: 1.93rem;
    }

    .banner img {
        width: 100%;
        height: 1.93rem;
    }

    .banner h2 {
        font-size: 0.23rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.29rem;
        position: absolute;
        top: 50%;
        margin-top: -0.16rem;
        left: 1.4rem;
        opacity: 0.3;
    }

    .content {
        width: 100%;
    }

    .content-top,
    .content-bottom {
        width: 100%;
        min-height: 1.72rem;
        background-color: #F5F5F7;
        overflow: hidden;
        padding-bottom: 0.1rem;
    }

    .top-left {
        width: 50%;
        min-height: 1.72rem;
        float: left;
    }

    .top-left img {
        width: 1.23rem;
        height: 1.13rem;
        margin: 19% 0 0 0.6rem;
    }

    .top-right {
        width: 50%;
        min-height: 1.72rem;
        float: left;
        padding: 0.43rem 0.68rem 0 0.05rem;
    }

    .top-right h3 {
        font-size: 0.05rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.1rem;
        opacity: 0.3;
    }

    .top-right p,
    .bottom-left p {
        font-size: 0.04rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(33, 33, 33, 1);
        line-height: 0.1rem;
        margin-top: 0.02rem;
        text-indent: 2em;
        opacity: 0.3;
    }

    .content-bottom {
        background-color: #fff;
    }

    .bottom-left {
        width: 45%;
        min-height: 1.72rem;
        float: left;
        padding-right: 0.07rem;
        text-align: center;
    }

    .bottom-left h3 {
        font-size: 0.12rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        line-height: 0.22rem;
        margin: 0.52rem 0 0 40%;
    }

    .bottom-left p {
        margin-left: 0.6rem;
    }

    .bottom-right {
        width: 55%;
        min-height: 1.72rem;
        float: left;
    }

    .bottom-right img {
        width: 1.23rem;
        height: 1.13rem;
        margin: 19% 0 0 0;
    }

    .city {
        width: 100%;
        height: 2.11rem;
        background-image: url('../assets/img/about/4.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-top: 0.74rem;
    }

    .city h3 {
        font-size: 0.13rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.24rem;
        text-align: center;
        opacity: 0.3;
    }

    .city p {
        font-size: 0.07rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(227, 227, 227, 1);
        line-height: 0.08rem;
        text-align: center;
        opacity: 0.3;
    }

    .credential {
        width: 100%;
        height: 1.83rem;
    }

    .credential h3 {
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(55, 55, 55, 1);
        line-height: 0.29rem;
        text-align: center;
        margin-top: 0.15rem;
    }
    .book {
        width: 65%;
        height: 2.26rem;
        overflow: hidden;
        margin: 0 auto;
        margin-top: 0.05rem;
    }
    .book-img,.book-type{
        width: 100%;
        height: 1.11rem;
        position: relative;
        margin-bottom: 0.05rem;
    }
    .img-1{
        width: 1.68rem;
        height: 1.11rem;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -0.84rem;
    }
    .img-2{
        width: 0.78rem;
        height: 1.05rem;
        float: left;
        margin-right: 0.06rem;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -0.79rem;

    }
    .img-2:nth-of-type(2){
        top: -0.01rem;
        left: 50%;
        margin-left: 0.03rem;
    }
    .book-1 {
        width: 60%;
        height: 2.73rem;
        overflow: hidden;
        margin: 0 auto;
    }
    .book-spe{
        width: 100%;
        height: 1.33rem;
        overflow: hidden;
        position: relative;
        margin-bottom: 0.07rem;
    }
    .img-3{
        width: 0.94rem;
        height: 1.33rem;
        float: left;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -1.02rem;
    }
    .img-3:nth-of-type(2){
        top: -0.01rem;
        left: 50%;
        margin-left: 0.07rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/about.vue